<template>
    <div class="background">
        <!--<div style="font-size:0;">-->
            <!--<img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NVQBaqj.jpg" width="100%" />-->
        <!--</div>-->

        <div style="padding:0.5rem 0;">
            <div class="inputForm">
                <van-field v-model="query.certificateName" placeholder="请填写姓名" label="姓名" clearable/>
                <van-field v-model="query.certificateNumber" placeholder="请填写身份证号" label="身份证号" clearable/>
                <van-field v-model="query.mobilePhone" placeholder="请填写联系电话" label="联系电话" clearable/>
                <van-field v-model="query.area" label="所在地区" placeholder="请选择省、市、区" clearable @click="showArea=true"/>
                <van-field v-model="query.address" label="详细地址" placeholder="请填写道路、小区、门牌号等" clearable/>
                <!--<van-field v-model="query.orderMobile" label="新手机号" placeholder="请选择新手机号" clearable @click="openPhonePopup"/>-->
                <span style="font-size:1rem;color:#1ba2ec;" @click="openProtocol">请点击查看《中国移动用户入网协议》</span>
                <van-button type="danger" size="large" round @click="submit" style="margin-top:0.5rem;height:3rem;">免费领取，包邮到家</van-button>
            </div>
        </div>
        <!--<div style="font-size:0;">-->
            <!--<img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NVQA7Px.jpg" width="100%" />-->
            <!--<img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NVQA5vK.jpg" width="100%" />-->
        <!--</div>-->
        <van-popup v-model="showArea" position="bottom">
            <van-picker show-toolbar title="地区选择" :columns="areaTreeList" @confirm="onAreaConfirm" @cancel="showArea=false"/>
        </van-popup>
        <van-dialog v-model="showProtocol" title="用户入网协议">
            <div style="height:35rem;margin:1rem;overflow-y:scroll;text-align:left;">
                <p v-html="protocol">{{protocol}}</p>
            </div>
        </van-dialog>
        <van-popup v-model="showPhone" position="bottom">
            <van-picker show-toolbar title="新手机号选择" :columns="phoneNumberList" @confirm="onPhoneConfirm" @cancel="showPhone=false"/>
        </van-popup>
        <van-dialog v-model="showAppList" title="专属流量使用APP清单">
          <div style="height:35rem;margin:1rem;overflow-y:scroll;text-align:left;">
            <p v-html="appList">{{appList}}</p>
          </div>
        </van-dialog>
    </div>
</template>

<script>
    import saasAPI from '@/api/saas';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                linkNum:"6htV8p3Z",
                query: {
                    pid: this.$route.query.pid,
                },
                areaTreeList: [],
                showArea: false,
                showProtocol: false,
                phoneList: [],
                phoneNumberList: [],
                showPhone: false,
                protocol: '',
                showAppList: false,
                appList: '哔哩哔哩、快手（含快手极速版）、芒果 TV、新浪微博、网易云音乐、喜马拉雅<br /><br />' +
                    '腾讯系：<br />' +
                    '手机 QQ、腾讯视频、和平精英、酷狗音乐、酷我音乐、手游加速器<br /><br />' +
                    '阿里系：<br />' +
                    '优酷视频、手机淘宝、点淘、手机天猫、支付宝、钉钉、口碑、闲鱼、聚划算、蚂蚁财富<br /><br />' +
                    '百度系：<br />' +
                    '百度、爱奇艺、百度地图、 手机助手、百度输入法、好看视频、百度贴吧、百度文库、百度翻译、百度糯米、百度百科、秒懂百科、百度知道、全民小视频。爱奇艺包含爱奇艺、爱奇艺随刻、爱奇艺泡泡、爱奇艺奇巴布、爱奇艺知识、爱奇艺漫画、奇秀、电视果<br /><br />' +
                    '抖音系：<br />' +
                    '抖音、抖音极速版、今日头条、西瓜视频、 抖音火山版、皮皮虾、懂车帝、FaceU 激萌、轻颜相机、飞书、飞聊、多闪、图虫、gogokid、时光相册、半次元、海豚股票、海豚财富、好好学习<br /><br />' +
                    '网易游戏：<br />' +
                    '一梦江湖、大话西游、决战平安京、梦幻西游、倩女幽魂、阴阳师、网易大神、大唐无双、第五人格、非人学园、孤岛先锋、光明大陆、花与剑、荒野行动、流星群侠传、率土之滨、梦幻西游 3D、秘境对决、明日之后、权力与纷争、神都夜行录、实况足球、坦克世界闪击战、天下、永远的七日之都、战国志、镇魔曲、三国如龙传、量子特攻<br /><br />' +
                    'VIVO 系：<br />' +
                    'vivo 应用商店、vivo 游戏中心、i 音乐、i 主题、vivo 官网、vivo 商城<br /><br />' +
                    '中国移动精品应用：<br />' +
                    '咪咕视频、咪咕音乐、咪咕阅读、咪咕快游、MM 应用商城、和彩云<br /><br />' +
                    '专属流量适用范围：<br />' +
                    '建议使用定向专属流量包前将 APP 升级至最新版本，请在 WIFI 功能关闭下使用专属流量功能，避免 WIFI 和移动网络频繁切换导致专属流量服务启动失败。客户端不包含在“定向流量”内的适用范围，特别说明如下：<br />' +
                    '① 客户端启动、登录；客户端内的插播广告（图片、文字及视频），弹幕，第三方的广告或直播、主播类视频，在线观看和下载缓存的第三方视频等。<br />' +
                    '② 手机号码处于国际或港澳台地区漫游状态下产生的流量。<br />' +
                    '③ 利用手机设置代理服务器或 VPN 等方式，访问 APP 所产生的流量。<br />' +
                    '④ 用无线上网卡、平板电脑、CPE、MIFI 等非手机设备使用产生的流量。<br />' +
                    '⑤ 手机作为热点使用产生的流量。<br />' +
                    '⑥ 使用 CMWAP 接入点方式，访问视频 APP 所产生的流量。',
            }
        },
        methods: {
            onAreaConfirm(value, index) {
                this.showArea = false;
                this.query.area = value.join(" ");
                let province = this.areaTreeList[index[0]];
                let city = province.children[index[1]];
                let district = city.children[index[2]];
                this.query.sendProvinceCode = province.provinceId;
                this.query.sendCityCode = city.cityId;
                this.query.sendDistrictCode = district.townId;
            },
            openPhonePopup() {
                if (!this.query.certificateNumber) {
                    this.$toast("请先填写身份证号");
                    return;
                }
                if (!this.query.sendProvinceCode || !this.query.sendCityCode) {
                    this.$toast("请先填写地区");
                    return;
                }
                saasAPI.loadCardMobile(this.query.certificateNumber, this.query.sendProvinceCode,
                    this.query.sendCityCode, this.query.numberKeyword,this.linkNum).then((result) =>{
                        if (!result.data || result.data.length < 1) {
                            this.$toast("该地区暂无可选号码");
                        }
                        this.phoneList = result.data;
                        let numberList = [];
                        this.phoneList.map(e => {
                            numberList.push(e.number);
                        });
                        this.phoneNumberList = numberList;
                        this.showPhone = true;
                });
            },
            onPhoneConfirm(value, index) {
                this.showPhone = false;
                this.query.orderMobile = this.phoneList[index].number;
                this.query.numberCheckCode = this.phoneList[index].checkCode;
            },
            openProtocol() {
                if (!this.query.sendProvinceCode) {
                    this.$toast("请先选择所在地区");
                    return;
                }
                saasAPI.loadCardProtocol(this.query.sendProvinceCode).then((result) => {
                    this.showProtocol = true;
                    this.protocol = result.data;
                })
            },
            submit() {
                if (!this.query.pid) {
                    this.$toast("链接参数有误");
                    return;
                }
                if (!this.query.certificateName || !this.query.certificateNumber
                    || !this.query.sendProvinceCode || !this.query.sendCityCode || !this.query.sendDistrictCode
                    || !this.query.address || !this.query.mobilePhone) {
                    this.$toast("请先填写相关信息");
                    return;
                }
                this.query.linkNum=this.linkNum;
                saasAPI.orderCardMobile(this.query).then(() => {
                    this.query = {};
                    this.query.pid = this.$route.query.pid;
                    this.$toast("提交成功");
                })
            },
        },
        created() {
            saasAPI.loadCardCode().then((result) => {
                if (result) {
                    let areaTree = result.data;
                    if (areaTree) {
                        areaTree.map(e => {
                            e.text = e.provinceName;
                            e.children = e.city;
                            if (e.children) {
                                e.children.map(e2 => {
                                    e2.text = e2.cityName;
                                    e2.children = e2.town;
                                    if (e2.children) {
                                        e2.children.map(e3 => {
                                            e3.text = e3.townName;
                                        })
                                    }
                                })
                            }
                        });
                        this.areaTreeList = areaTree;
                    }
                }
            }).catch(() => {
            });
            pvuvAPI.addPv("saas/funo", this.query.pid).then((result) => {
            });
        },
    }

</script>

<style lang="scss" scoped>
    .background {
        background: url('http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2MnkOzWA.jpg') no-repeat;
        background-size: 100% 100%;
        height: 180rem;
        padding-top: 32rem;
        text-align: center;
        /*padding: 0;*/
    }

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        border-radius: 1rem;
        padding: 0.5rem 1rem;
        text-align: center;
    }

</style>
